var _path, _stop, _stop2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgCommentActive2 = function SvgCommentActive2(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "commentActive2_svg__prefix__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h18v18H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#commentActive2_svg__prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 4.5c0-1.14.923-2.063 2.063-2.063h10.124c1.14 0 2.063.924 2.063 2.063v7.313c0 1.139-.923 2.062-2.063 2.062h-3.395l-3.031 1.97a.937.937 0 01-1.449-.786v-1.184h-2.25a2.062 2.062 0 01-2.062-2.063V4.5zM6 9a.937.937 0 100-1.875A.937.937 0 006 9zm3.938-.938a.937.937 0 11-1.875 0 .937.937 0 011.874 0zM12 9a.937.937 0 100-1.875A.937.937 0 0012 9z",
    fill: "url(#".concat(_id, ")")
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 1.875,
    y1: 2.438,
    x2: 15.419,
    y2: 16.67,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DA6FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37F"
  })))));
};
export default SvgCommentActive2;